import React from "react";

import { TCustomIcon } from "../../types";

const CustomIcon = ({ fill, strokeWidth, stroke, className }: TCustomIcon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill ? fill : "none"}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke={stroke ? stroke : "currentColor"}
      className={className ? className : "h-6 w-6"}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
      />
    </svg>
  );
};

export default CustomIcon;
